module.exports = __webpack_public_path__ + "img/hrc_thumb.4df65b82.jpg";